import axios from 'axios';

import { BASE_URL } from '../configs/envs';

export enum HttpMethod {
  Get = 'GET',
  Post = 'POST',
  Put = 'PUT',
  Patch = 'PATCH',
  Delete = 'DELETE',
}

const DEFAULT_TIMEOUT_MS = 15000;

export const httpClient = <T = unknown>(
  url: string,
  method: HttpMethod,
  data?: unknown,
  headers?: Record<string, string>,
  timeoutMs?: number
): Promise<T> => {
  return new Promise((resolve, reject) => {
    const params: {
      method: HttpMethod;
      url: string;
      timeout: number;
      data?: unknown;
      headers?: Record<string, string>;
    } = {
      method,
      url: `${BASE_URL}${url}`,
      timeout: timeoutMs ?? DEFAULT_TIMEOUT_MS,
    };
    if (data) {
      params.data = data;
    }

    if (headers) {
      params.headers = headers;
    }

    axios(params)
      .then((response) => {
        if (response.status > 199 && response.status < 300) {
          resolve(response.data);
        } else {
          reject('Response is not success');
        }
      })
      .catch((error) => {
        reject(error);
      });
  });
};
